export default function ( context, url ) {

    context.background = context.defaultBg;
    let img = new Image();
    img.src = url;
    img.onload = () => {

        if ( context.currentUrl === url ) {

            context.background = url;

        }

    };
    img.onerror = () => {

        if ( context.currentUrl === url ) {

            context.background = context.defaultBg;
            
        }

    };

};



// WEBPACK FOOTER //
// ./src/common/js/defaultBg.js